import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";

import {FormActions} from "@pg-mono/form";
import {parseSearch} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {searchFormFields} from "../constants/search_form_constants";
import {filtersModalOpened, setFiltersShown} from "../slices/filters_visibility_slice";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {isRestoredFiltersEnabled} from "../utils/restored_filters";

interface IUseFilterProps {
    closeMobileFilterModal: () => void;
    onAfterChange: () => void;
    onSubmit: (formValues: SearchFormValuesType) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions: FormActions<Record<keyof typeof searchFormFields, any>>;
    formValues: SearchFormValuesType;
    enableFiltersAutoOpen?: boolean;
    disableAutoShowcase?: boolean;
    onClose?: () => void;
}

export const useFilter = (props: IUseFilterProps) => {
    const {formValues, enableFiltersAutoOpen = false, closeMobileFilterModal, onSubmit, disableAutoShowcase = false} = props;
    const location = useLocation();
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [lastSearchedRegions, setLastSearchedRegions] = useState([]);
    const filtersWasShown = useSelector((state: IRPStore) => state.search.filtersVisibility.wasSeen);
    const dispatch = useDispatch();
    const currentPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const {isMobile} = useUserDevice();

    // Check if filters were restored from recent filters
    const urlParams = parseSearch(location.search);
    const filtersRestored = isRestoredFiltersEnabled(urlParams.restored_filters);

    useEffect(() => {
        if (isMobile) {
            return;
        }

        // Don't auto-open filters if they were restored from recent filters
        if (filtersRestored) {
            dispatch(setFiltersShown({wasSeen: true}));
            return;
        }

        const roomsFilterInUse = Object.values(formValues.rooms).find((el) => el !== "");
        const priceFilterInUse = Object.values(formValues.price).find((el) => el !== "");
        const isFirstPage = currentPage === 1;
        const searchedRegions = formValues.search.regions;

        if (roomsFilterInUse && priceFilterInUse && !filtersWasShown && !disableAutoShowcase) {
            dispatch(setFiltersShown({wasSeen: true}));
        }

        if (
            searchedRegions?.length > 0 &&
            (!roomsFilterInUse || !priceFilterInUse) &&
            (!filtersWasShown || searchedRegions.length !== lastSearchedRegions.length) &&
            isFirstPage &&
            enableFiltersAutoOpen &&
            !disableAutoShowcase
        ) {
            dispatch(setFiltersShown({wasSeen: true}));
            dispatch(filtersModalOpened({filtersModalOpened: true}));
            setLastSearchedRegions(searchedRegions);
            setDrawerOpen(true);
        }
    }, [formValues, filtersWasShown, currentPage, enableFiltersAutoOpen, filtersRestored]);

    const closeDrawer = () => {
        if (!filtersWasShown) {
            dispatch(setFiltersShown({wasSeen: true}));
        }
        dispatch(filtersModalOpened({filtersModalOpened: false}));
        setDrawerOpen(false);
        props.onClose?.();
    };

    const resetFilters = () => {
        const newFormValues = {
            ...(fromJsonValues(searchFormFields, {distance: 5}) as SearchFormValuesType),
            search: props.formValues.search
        };

        props.formActions.update(newFormValues);
        onSubmit(newFormValues);
        closeMobileFilterModal();
        closeDrawer();
    };

    return {
        isDrawerOpen,
        setDrawerOpen,
        closeDrawer,
        resetFilters
    };
};
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router";

import {FormActions} from "@pg-mono/form";
import {parseSearch} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {fromJsonValues} from "../../form/translate/from_json_values";
import {searchFormFields} from "../constants/search_form_constants";
import {filtersModalOpened, setFiltersShown} from "../slices/filters_visibility_slice";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {isRestoredFiltersEnabled} from "../utils/restored_filters";

interface IUseFilterProps {
    closeMobileFilterModal: () => void;
    onAfterChange: () => void;
    onSubmit: (formValues: SearchFormValuesType) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formActions: FormActions<Record<keyof typeof searchFormFields, any>>;
    formValues: SearchFormValuesType;
    enableFiltersAutoOpen?: boolean;
    disableAutoShowcase?: boolean;
    onClose?: () => void;
}

export const useFilter = (props: IUseFilterProps) => {
    const {formValues, enableFiltersAutoOpen = false, closeMobileFilterModal, onSubmit, disableAutoShowcase = false} = props;
    const location = useLocation();
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [lastSearchedRegions, setLastSearchedRegions] = useState([]);
    const filtersWasShown = useSelector((state: IRPStore) => state.search.filtersVisibility.wasSeen);
    const dispatch = useDispatch();
    const currentPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const {isMobile} = useUserDevice();

    // Check if filters were restored from recent filters
    const urlParams = parseSearch(location.search);
    const filtersRestored = isRestoredFiltersEnabled(urlParams.restored_filters);

    useEffect(() => {
        if (isMobile) {
            return;
        }

        // Don't auto-open filters if they were restored from recent filters
        if (filtersRestored) {
            dispatch(setFiltersShown({wasSeen: true}));
            return;
        }

        const roomsFilterInUse = Object.values(formValues.rooms).find((el) => el !== "");
        const priceFilterInUse = Object.values(formValues.price).find((el) => el !== "");
        const isFirstPage = currentPage === 1;
        const searchedRegions = formValues.search.regions;

        if (roomsFilterInUse && priceFilterInUse && !filtersWasShown && !disableAutoShowcase) {
            dispatch(setFiltersShown({wasSeen: true}));
        }

        if (
            searchedRegions?.length > 0 &&
            (!roomsFilterInUse || !priceFilterInUse) &&
            (!filtersWasShown || searchedRegions.length !== lastSearchedRegions.length) &&
            isFirstPage &&
            enableFiltersAutoOpen &&
            !disableAutoShowcase
        ) {
            dispatch(setFiltersShown({wasSeen: true}));
            dispatch(filtersModalOpened({filtersModalOpened: true}));
            setLastSearchedRegions(searchedRegions);
            setDrawerOpen(true);
        }
    }, [formValues, filtersWasShown, currentPage, enableFiltersAutoOpen, filtersRestored]);

    const closeDrawer = () => {
        if (!filtersWasShown) {
            dispatch(setFiltersShown({wasSeen: true}));
        }
        dispatch(filtersModalOpened({filtersModalOpened: false}));
        setDrawerOpen(false);
        props.onClose?.();
    };

    const resetFilters = () => {
        const newFormValues = {
            ...(fromJsonValues(searchFormFields, {distance: 5}) as SearchFormValuesType),
            search: props.formValues.search
        };

        props.formActions.update(newFormValues);
        onSubmit(newFormValues);
        closeMobileFilterModal();
        closeDrawer();
    };

    return {
        isDrawerOpen,
        setDrawerOpen,
        closeDrawer,
        resetFilters
    };
};
